import { dynamicStyling } from 'styles';

export function LogoIcon({ className, size = 50 }: { size?: number; className?: string }) {
  return (
    <svg
      viewBox="0 0 1080 1080"
      {...dynamicStyling({
        size,

        className: ['text-inherit shrink-0', className],
      })}
    >
      <defs>
        <clipPath id="clippath">
          <path
            className="cls-1"
            d="m269.77,859.06c28.53,31.92,61.9,58.51,98.65,78.34,2.42,1.45,4.84,2.9,7.25,3.87,50.29,26.11,106.87,40.14,164.89,40.14s116.54-14.02,167.79-40.62c.48-.48,1.45-.97,1.93-1.45,38.68-20.31,72.53-46.9,101.55-79.3-69.15-63.83-162.96-103-271.76-103s-202.13,38.68-270.31,102.03h0Zm271.27-184.23c-67.7,0-122.34-54.64-122.34-122.34s54.64-122.34,122.34-122.34,122.34,54.64,122.34,122.34-54.64,122.34-122.34,122.34h0Z"
          />
        </clipPath>
      </defs>
      <path
        fill="hsl(var(--primary))"
        d="m269.77,859.06c28.53,31.92,61.9,58.51,98.65,78.34,2.42,1.45,4.84,2.9,7.25,3.87,50.29,26.11,106.87,40.14,164.89,40.14s116.54-14.02,167.79-40.62c.48-.48,1.45-.97,1.93-1.45,38.68-20.31,72.53-46.9,101.55-79.3-69.15-63.83-162.96-103-271.76-103s-202.13,38.68-270.31,102.03h0Zm271.27-184.23c-67.7,0-122.34-54.64-122.34-122.34s54.64-122.34,122.34-122.34,122.34,54.64,122.34,122.34-54.64,122.34-122.34,122.34h0Z"
      />
      <g style={{ clipPath: 'url(#clippath)' }}>
        <polyline
          fill="hsl(var(--primary))"
          points="156.61 543.3 257.19 507.52 448.2 1041.85 348.1 1077.63"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="256.23 508 259.13 507.04 450.13 1041.36 447.23 1042.33"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="258.16 507.04 260.58 506.07 452.07 1040.4 449.17 1041.85"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="260.1 506.55 262.51 505.59 454 1039.91 451.1 1040.88"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="261.55 505.59 264.45 504.62 455.94 1039.43 453.03 1040.4"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="263.48 505.1 266.38 504.13 457.39 1038.46 454.97 1039.43"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="265.41 504.62 268.32 503.65 459.32 1037.98 456.42 1038.95"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="267.35 503.65 270.25 502.68 461.25 1037.5 458.35 1038.46"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="269.28 503.17 272.18 502.2 463.19 1036.53 460.29 1037.5"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="271.22 502.68 274.12 501.23 465.12 1036.05 462.22 1037.01"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="273.15 501.72 275.57 500.75 467.06 1035.08 464.16 1036.05"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="274.6 501.23 277.5 500.27 468.99 1034.59 466.09 1035.56"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="276.54 500.27 279.44 499.3 470.93 1034.11 468.02 1035.08"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="278.47 499.78 281.37 498.82 472.38 1033.14 469.96 1034.11"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="280.4 499.3 283.31 498.33 474.31 1032.66 471.41 1033.63"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="282.34 498.33 285.24 497.37 476.24 1031.69 473.34 1033.14"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="284.27 497.85 287.17 496.88 478.18 1031.21 475.28 1032.18"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="286.21 496.88 289.11 495.91 480.11 1030.73 477.21 1031.69"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="288.14 496.4 290.56 495.43 482.05 1029.76 479.15 1030.73"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="289.59 495.91 292.49 494.95 483.98 1029.28 481.08 1030.24"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="291.53 494.95 294.43 493.98 485.92 1028.79 483.01 1029.76"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="293.46 494.46 296.36 493.5 487.37 1027.83 484.95 1028.79"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="295.39 493.98 298.3 492.53 489.3 1027.34 486.4 1028.31"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="297.33 493.01 300.23 492.05 491.23 1026.37 488.33 1027.34"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="299.26 492.53 302.16 491.56 493.17 1025.89 490.27 1026.86"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="301.2 491.56 304.1 490.6 495.1 1025.41 492.2 1026.37"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="303.13 491.08 305.55 490.11 497.04 1024.44 494.14 1025.41"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="304.58 490.6 307.48 489.63 498.97 1023.96 496.07 1024.92"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="306.52 489.63 309.42 488.66 500.42 1022.99 498 1024.44"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="308.45 489.14 311.35 488.18 502.36 1022.51 499.94 1023.47"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="310.39 488.18 313.29 487.21 504.29 1022.02 501.39 1022.99"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="312.32 487.69 315.22 486.73 506.22 1021.06 503.32 1022.02"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="314.25 487.21 317.15 486.24 508.16 1020.57 505.26 1021.54"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="316.19 486.24 319.09 485.28 510.09 1019.6 507.19 1021.06"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="318.12 485.76 320.54 484.79 512.03 1019.12 509.13 1020.09"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="319.57 485.28 322.47 483.83 513.96 1018.64 511.06 1019.6"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="321.51 484.31 324.41 483.34 515.41 1017.67 512.99 1018.64"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="323.44 483.83 326.34 482.86 517.35 1017.19 514.93 1018.15"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="325.38 482.86 328.28 481.89 519.28 1016.7 516.38 1017.67"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="327.31 482.38 330.21 481.41 521.22 1015.74 518.31 1016.7"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="329.24 481.89 332.15 480.44 523.15 1015.25 520.25 1016.22"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="331.18 480.92 334.08 479.96 525.08 1014.29 522.18 1015.25"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="333.11 480.44 335.53 479.47 527.02 1013.8 524.12 1014.77"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="334.56 479.47 337.46 478.51 528.95 1013.32 526.05 1014.29"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="336.5 478.99 339.4 478.02 530.4 1012.35 527.98 1013.32"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="338.43 478.51 341.33 477.54 532.34 1011.87 529.92 1012.84"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="340.37 477.54 343.27 476.57 534.27 1010.9 531.37 1012.35"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="342.3 477.06 345.2 476.09 536.21 1010.42 533.3 1011.38"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="344.23 476.09 347.14 475.12 538.14 1009.93 535.24 1010.9"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="346.17 475.61 349.07 474.64 540.07 1008.97 537.17 1009.93"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="348.1 475.12 350.52 474.15 542.01 1008.48 539.11 1009.45"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="349.55 474.15 352.45 473.19 543.94 1008 541.04 1008.97"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="351.49 473.67 354.39 472.7 545.39 1007.03 542.97 1008"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="353.42 473.19 356.32 471.74 547.33 1006.55 544.91 1007.52"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="355.36 472.22 358.26 471.25 549.26 1005.58 546.36 1006.55"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="357.29 471.74 360.19 470.77 551.2 1005.1 548.29 1006.07"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="359.22 470.77 362.13 469.8 553.13 1004.61 550.23 1005.58"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="361.16 470.29 364.06 469.32 555.06 1003.65 552.16 1004.61"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="363.09 469.8 365.51 468.84 557 1003.16 554.1 1004.13"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="364.54 468.84 367.44 467.87 558.93 1002.2 556.03 1003.65"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="366.48 468.35 369.38 467.38 560.38 1001.71 557.97 1002.68"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="368.41 467.38 371.31 466.42 562.32 1001.23 559.9 1002.2"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="370.35 466.9 373.25 465.93 564.25 1000.26 561.35 1001.23"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="372.28 466.42 375.18 465.45 566.19 999.78 563.28 1000.75"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="374.21 465.45 377.12 464.48 568.12 999.3 565.22 1000.26"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="376.15 464.97 379.05 464 570.05 998.33 567.15 999.3"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="378.08 464.48 380.5 463.03 571.99 997.84 569.09 998.81"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="379.53 463.52 382.43 462.55 573.92 996.88 571.02 997.84"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="381.47 463.03 384.37 462.07 575.37 996.39 572.96 997.36"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="383.4 462.07 386.3 461.1 577.31 995.91 574.89 996.88"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="385.34 461.58 388.24 460.61 579.24 994.94 576.34 995.91"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="387.27 461.1 390.17 460.13 581.18 994.46 578.27 995.43"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="389.2 460.13 392.11 459.16 583.11 993.49 580.21 994.94"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="391.14 459.65 393.56 458.68 585.04 993.01 582.14 993.98"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="393.07 458.68 395.49 457.71 586.98 992.53 584.08 993.49"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="394.52 458.2 397.43 457.23 588.91 991.56 586.01 992.53"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="396.46 457.71 399.36 456.75 590.36 991.07 587.95 992.04"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="398.39 456.75 401.29 455.78 592.3 990.59 589.88 991.56"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="400.33 456.26 403.23 455.3 594.23 989.62 591.33 990.59"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="402.26 455.78 405.16 454.33 596.17 989.14 593.26 990.11"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="404.19 454.81 407.1 453.84 598.1 988.17 595.2 989.14"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="406.13 454.33 408.55 453.36 600.03 987.69 597.13 988.66"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="408.06 453.36 410.48 452.39 601.97 987.21 599.07 988.17"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="409.51 452.88 412.42 451.91 603.9 986.24 601 987.21"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="411.45 452.39 414.35 451.43 605.35 985.76 602.94 986.72"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="413.38 451.43 416.28 450.46 607.29 984.79 604.87 986.24"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="415.32 450.94 418.22 449.98 609.22 984.3 606.32 985.27"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="417.25 449.98 420.15 449.01 611.16 983.82 608.25 984.79"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="419.19 449.49 422.09 448.53 613.09 982.85 610.19 983.82"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="421.12 449.01 423.54 448.04 615.02 982.37 612.12 983.34"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="423.05 448.04 425.47 447.08 616.96 981.89 614.06 982.85"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="424.5 447.56 427.41 446.59 618.89 980.92 615.99 981.89"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="426.44 447.08 429.34 445.62 620.34 980.44 617.93 981.4"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="428.37 446.11 431.27 445.14 622.28 979.47 619.38 980.44"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="430.31 445.62 433.21 444.66 624.21 978.99 621.31 979.95"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="432.24 444.66 435.14 443.69 626.15 978.5 623.25 979.47"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="434.18 444.17 437.08 443.21 628.08 977.53 625.18 978.5"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="436.11 443.69 438.53 442.72 630.02 977.05 627.11 978.02"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="438.04 442.72 440.46 441.76 631.95 976.08 629.05 977.53"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="439.49 442.24 442.4 441.27 633.88 975.6 630.98 976.57"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="441.43 441.27 444.33 440.31 635.33 975.12 632.92 976.08"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="443.36 440.79 446.26 439.82 637.27 974.15 634.37 975.12"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="445.3 440.31 448.2 439.34 639.2 973.67 636.3 974.63"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="447.23 439.34 450.13 438.37 641.14 973.18 638.24 974.15"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="449.17 438.85 452.07 437.89 643.07 972.22 640.17 973.18"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="451.1 438.37 453.52 436.92 645.01 971.73 642.1 972.7"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="453.03 437.4 455.45 436.44 646.94 970.77 644.04 971.73"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="454.48 436.92 457.39 435.95 648.87 970.28 645.97 971.25"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="456.42 435.95 459.32 434.99 650.32 969.8 647.91 970.77"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="458.35 435.47 461.25 434.5 652.26 968.83 649.36 969.8"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="460.29 434.99 463.19 434.02 654.19 968.35 651.29 969.31"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="462.22 434.02 465.12 433.05 656.13 967.38 653.23 968.35"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="464.16 433.54 467.06 432.57 658.06 966.9 655.16 967.86"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="466.09 432.57 468.51 431.6 660 966.41 657.09 967.38"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="468.02 432.09 470.44 431.12 661.93 965.45 659.03 966.41"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="469.47 431.6 472.38 430.63 663.86 964.96 660.96 965.93"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="471.41 430.63 474.31 429.67 665.31 964 662.9 965.45"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="473.34 430.15 476.24 429.18 667.25 963.51 664.35 964.48"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="475.28 429.18 478.18 428.22 669.18 963.03 666.28 964"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="477.21 428.7 480.11 427.73 671.12 962.06 668.22 963.03"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="479.15 428.22 482.05 427.25 673.05 961.58 670.15 962.54"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="481.08 427.25 483.5 426.28 674.99 961.09 672.08 962.06"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="483.01 426.77 485.43 425.8 676.92 960.13 674.02 961.09"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="484.46 426.28 487.37 424.83 678.85 959.64 675.95 960.61"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="486.4 425.32 489.3 424.35 680.3 958.68 677.89 959.64"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="488.33 424.83 491.23 423.86 682.24 958.19 679.34 959.16"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="490.27 423.86 493.17 422.9 684.17 957.71 681.27 958.68"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="492.2 423.38 495.1 422.41 686.11 956.74 683.21 957.71"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="494.14 422.9 497.04 421.93 688.04 956.26 685.14 957.23"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="496.07 421.93 498.49 420.96 689.98 955.29 687.07 956.74"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="498 421.45 500.42 420.48 691.91 954.81 689.01 955.78"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="499.45 420.48 502.36 419.51 693.84 954.32 690.94 955.29"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="501.39 420 504.29 419.03 695.29 953.36 692.88 954.32"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="503.32 419.51 506.22 418.55 697.23 952.87 694.33 953.84"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="505.26 418.55 508.16 417.58 699.16 952.39 696.26 953.36"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="507.19 418.06 510.09 417.1 701.1 951.42 698.2 952.39"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="509.13 417.58 512.03 416.13 703.03 950.94 700.13 951.91"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="511.06 416.61 513.48 415.64 704.97 949.97 702.06 950.94"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="512.51 416.13 515.41 415.16 706.9 949.49 704 950.46"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="514.45 415.16 517.35 414.19 708.83 949.01 705.93 949.97"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="516.38 414.68 519.28 413.71 710.28 948.04 707.87 949.01"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="518.31 414.19 521.22 413.23 712.22 947.55 709.32 948.52"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="520.25 413.23 523.15 412.26 714.15 946.59 711.25 948.04"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="522.18 412.74 525.08 411.78 716.09 946.1 713.19 947.07"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="524.12 411.78 527.02 410.81 718.02 945.62 715.12 946.59"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="526.05 411.29 528.47 410.33 719.96 944.65 717.05 945.62"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="527.5 410.81 530.4 409.84 721.89 944.17 718.99 945.14"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="529.44 409.84 532.34 408.88 723.82 943.69 720.92 944.65"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="531.37 409.36 534.27 408.39 725.28 942.72 722.86 943.69"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="533.3 408.88 536.21 407.42 727.21 942.24 724.31 943.2"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="535.24 407.91 538.14 406.94 729.14 941.27 726.24 942.24"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="537.17 407.42 540.07 406.46 731.08 940.79 728.18 941.75"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="539.11 406.46 542.01 405.49 733.01 940.3 730.11 941.27"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="541.04 405.97 543.46 405.01 734.95 939.33 732.04 940.3"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="542.49 405.49 545.39 404.52 736.88 938.85 733.98 939.82"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="544.43 404.52 547.33 403.56 738.33 937.88 735.91 939.33"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="546.36 404.04 549.26 403.07 740.27 937.4 737.85 938.37"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="548.29 403.07 551.2 402.11 742.2 936.92 739.3 937.88"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="550.23 402.59 553.13 401.62 744.13 935.95 741.23 936.92"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="552.16 402.11 555.06 401.14 746.07 935.47 743.17 936.43"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="554.1 401.14 557 400.17 748 934.98 745.1 935.95"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="556.03 400.65 558.45 399.69 749.94 934.02 747.04 934.98"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="557.48 400.17 560.38 398.72 751.87 933.53 748.97 934.5"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="559.42 399.2 562.32 398.24 753.32 932.56 750.9 933.53"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="561.35 398.72 564.25 397.75 755.26 932.08 752.84 933.05"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="563.28 397.75 566.19 396.79 757.19 931.6 754.29 932.56"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="565.22 397.27 568.12 396.3 759.12 930.63 756.22 931.6"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="567.15 396.79 570.05 395.82 761.06 930.15 758.16 931.11"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="569.09 395.82 571.99 394.85 762.99 929.18 760.09 930.63"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="571.02 395.34 573.44 394.37 764.93 928.7 762.03 929.66"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="572.47 394.37 575.37 393.4 766.86 928.21 763.96 929.18"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="574.41 393.88 577.31 392.92 768.31 927.25 765.89 928.21"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="576.34 393.4 579.24 392.43 770.25 926.76 767.83 927.73"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="578.27 392.43 581.18 391.47 772.18 926.28 769.28 927.25"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="580.21 391.95 583.11 390.98 774.11 925.31 771.21 926.28"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="582.14 391.47 585.04 390.02 776.05 924.83 773.15 925.79"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="584.08 390.5 586.98 389.53 777.98 923.86 775.08 924.83"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="586.01 390.02 588.43 389.05 779.92 923.38 777.02 924.34"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="587.46 389.05 590.36 388.08 781.85 922.89 778.95 923.86"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="589.4 388.57 592.3 387.6 783.3 921.93 780.88 922.89"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="591.33 388.08 594.23 387.11 785.24 921.44 782.82 922.41"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="593.26 387.11 596.17 386.15 787.17 920.48 784.27 921.93"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="595.2 386.63 598.1 385.66 789.1 919.99 786.2 920.96"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="597.13 385.66 600.03 384.7 791.04 919.51 788.14 920.48"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="599.07 385.18 601.97 384.21 792.97 918.54 790.07 919.51"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="601 384.7 603.42 383.73 794.91 918.06 792.01 919.02"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="602.45 383.73 605.35 382.76 796.84 917.57 793.94 918.54"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="604.39 383.25 607.29 382.28 798.29 916.61 795.87 917.57"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="606.32 382.76 609.22 381.31 800.23 916.12 797.81 917.09"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="608.25 381.8 611.16 380.83 802.16 915.16 799.26 916.12"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="610.19 381.31 613.09 380.34 804.09 914.67 801.19 915.64"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="612.12 380.34 615.02 379.38 806.03 914.19 803.13 915.16"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="614.06 379.86 616.96 378.89 807.96 913.22 805.06 914.19"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="615.99 379.38 618.41 378.41 809.9 912.74 807 913.71"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="617.44 378.41 620.34 377.44 811.83 911.77 808.93 912.74"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="619.38 377.93 622.28 376.96 813.28 911.29 810.86 912.25"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="621.31 376.96 624.21 375.99 815.22 910.8 812.8 911.77"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="623.25 376.48 626.15 375.51 817.15 909.84 814.25 910.8"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="625.18 375.99 628.08 375.03 819.08 909.35 816.18 910.32"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="627.11 375.03 630.02 374.06 821.02 908.39 818.12 909.84"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="629.05 374.54 631.47 373.57 822.95 907.9 820.05 908.87"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="630.98 373.57 633.4 372.61 824.89 907.42 821.99 908.39"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="632.43 373.09 635.33 372.12 826.82 906.45 823.92 907.42"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="634.37 372.61 637.27 371.64 828.27 905.97 825.85 906.94"
        />
        <polyline
          fill="hsl(var(--primary))"
          points="636.3 371.64 636.78 371.64 827.79 905.97 827.79 906.45"
        />
      </g>
      <path
        fill="currentColor"
        d="m993.85,486.73l-43.51-13.94-25.27-8.1c-9.65-44.59-26.75-86.35-50.28-123.76l11.11-21.5,20.77-40.19c-26.04-34.15-56.85-64.54-91.5-90.2l-40.76,20.47-21.87,10.99c-37.25-22.62-79.26-39.23-125.1-48.46l-8.59-26.05-14.15-42.9c-21.13-2.94-42.72-4.5-64.69-4.5s-43.56,1.56-64.69,4.5l-14.15,42.9-8.98,27.21c-44.59,9.62-85.57,26.28-122.04,48.64l-24.55-12.33-40.76-20.47c-34.64,25.67-65.47,56.05-91.5,90.2l20.77,40.19,12.76,24.7c-22.71,36.35-39.38,76.72-49.1,119.65l-28.1,9.01-43.51,13.94c-2.98,20.84-4.57,42.12-4.57,63.77s1.58,42.94,4.57,63.77l43.51,13.95,26.67,8.55c9.24,44.43,25.86,86.11,48.77,123.53,4.26,6.96,8.72,13.78,13.41,20.43,26.35-28.4,56.21-53.29,89.26-73.79,5.77-3.58,11.63-7.04,17.6-10.35-24.66-42.07-38.68-91.39-38.68-144.1v-1.93c0-146.52,103.96-265.47,253.38-265.47s255.8,121.37,255.8,267.41v1.93c0,52.71-13.54,101.55-37.72,142.65,5,2.84,9.93,5.77,14.79,8.79,33.29,20.68,63.5,45.63,89.65,73.89,4.39-6.15,8.6-12.44,12.62-18.85,23.69-37.79,40.76-79.92,50.25-124.73l24.87-7.97,43.51-13.94c2.98-20.84,4.57-42.12,4.57-63.77s-1.58-42.94-4.57-63.77Z"
      />
    </svg>
  );
}
